<template>
  <Loading
    :contentSize="true"
    :state="loading"
    :hideInside="hide"
  >
    <table
      cellspacing="0"
      cellpadding="0"
      border="0"
      class="tasks items"

      v-if="tasks && tasks.length"
    >
      <tr>
        <th
          v-if="type === null"
        >{{ $t( "TaskType" ) }}</th>
        <th>{{ $t( "TaskCreated" ) }}</th>
        <th>{{ $t( "TaskStarted" ) }}</th>
        <th>{{ $t( "TaskFinished" ) }}</th>
        <th>{{ $t( "TaskAutoremove" ) }}</th>
        <th>{{ $t( "TaskStatus" ) }}</th>
        <th>{{ $t( "TaskErrorsCount" ) }}</th>
        <th>{{ $t( "TaskAttachments" ) }}</th>
        <th></th>
      </tr>

      <tr
        v-for="task in tasks"
        :key="task.id"

        class="item"
      >
        <td
          class="type"
          v-if="type === null"
        >{{ $t( task.type ) }}</td>
        <td class="datetime"><span>{{ date( task.timeCreated ) }}</span></td>
        <td class="datetime"><span>{{ date( task.timeStarted ) }}</span></td>
        <td class="datetime"><span>{{ date( task.timeFinished ) }}</span></td>
        <td class="autoremove" v-html="timeToHTML( task.timeAutoremove )"></td>
        <td class="progress">
          <div
            class="bar"

            v-if="task.status === $options.taskStatuses.running"
            :style="{ '--amount': task.progress ? task.progress : 0 }"
          />
          <div
            v-else
            class="status"
            :class="taskStatus( task.status )"
          >
            {{ $t( taskStatus( task.status ) ) }}
          </div>
        </td>
        <td class="errorsCount">
          <span
            v-if="task.errorsCount"
            @click="errorsOpen( task.id )">{{ task.errorsCount }}</span>
        </td>
        <td class="attachments">
          <a
            :href="$options.api.path2url( '/scheduler/' + task.id + '/attachment/' + aid )"
            @click="download( task, aid, $event )"

            :download="a.name"
            v-if="task.attachments"
            v-for="( a, aid ) in task.attachments"
            :key="aid"
          >{{ a.name }}</a>
        </td>
        <td
          class="controls"
        >
          <button
            @click="taskCommand( task, 'run' )"
            :title="$t( 'run' )"
            :class="!taskIsStopped( task ) ? 'disabled' : ''"
          >
            <Icon
              symbol="run"
              size="1.2em"
            />
          </button>
          <button
            @click="taskCommand( task, 'stop' )"
            :title="$t( 'stop' )"
            :class="taskIsStopped( task ) ? 'disabled' : ''"
          >
            <Icon
              symbol="stop"
              size="1.2em"
            />
          </button>
          <button
            @click="taskCommand( task, 'remove' )"
            :title="$t( 'remove' )"
          >
            <Icon
              symbol="trashcan"
              size="1.2em"
            />
          </button>
        </td>
      </tr>
    </table>
    <div
      class="empty"
      v-else
    >
      {{ $t( "noTasksFound" ) }}
    </div>

    <slot></slot>
<!--
    <div
      @click="taskCreate()"
      style="margin: 1em; font-weight: bold; cursor: pointer; background-color: #40B8ED; color: #FFFFFF; display: inline-block; padding: 0 0.5em; border-radius: 0.5em;"
    >task create</div>

    <div
      @click="taskCreate( 'XLSexport' )"
      style="margin: 1em; font-weight: bold; cursor: pointer; background-color: #40B8ED; color: #FFFFFF; display: inline-block; padding: 0 0.5em; border-radius: 0.5em;"
    >XLS export</div>
-->
    <Modal
      :show="errorsShow"
      :title="$t( 'TaskErrors' )"
      acceptButtonText="Ok"
      cancelButtonText=""
      @accept="errorsShow = false"
      @close="errorsShow = false"
    >
      <Loading
        :contentSize="true"
        :state="errors === null"
        :hideInside="true"
      >
        <template
          v-if="errors && errors.length"
        >
          <!-- errors is an array of strings -->
          <table
            v-if="errorsStrings"
            cellspacing="0"
            cellpadding="0"
            border="0"
            class="errors items"
          >
            <caption></caption>
            <tr
              v-for="err in errorsStrings"
              :key="err"
            >
              <td>{{ err }}</td>
            </tr>
          </table>

          <!--
            errors is an array of arrays like [ [ prop1: ..., prop2: ..., prop3: ..., ... ], ... ], number of props must be equal in all objects
          -->
          <template
            v-if="errorsArrays"
          >
            <br
              v-if="errorsStrings"
            />

            <!--
              if first row is header like [ header, translation prop1 id, translation prop2 id, ... ], ... }
              header - it is string "header"
              translation prop - id of column name for i18n
            -->
            <template
              v-if="errorsArrays[0][0] == 'header' && errorsArrays.length > 1 && errorsArrays[0].length == errorsArrays[1].length + 1"
            >
              <table
                cellspacing="0"
                cellpadding="0"
                border="0"
                class="errors items"
              >
                <caption></caption>
                <tr>
                  <th
                    v-if="i > 0"

                    v-for="( errH, i ) in errorsArrays[0]"
                    :key="i"
                  >
                    {{ $t( errH ) }}
                  </th>
                </tr>
                <tr
                  v-if="i > 0"

                  v-for="( err, i ) in errorsArrays"
                  :key="i"
                >
                  <td
                    v-for="( errProp, j ) in err"
                    :key="i + '_' + j"
                  >{{ errProp }}</td>
                </tr>
              </table>
            </template>
            <template
              v-else
            >
              <table
                cellspacing="0"
                cellpadding="0"
                border="0"
                class="errors items"
              >
                <caption></caption>
                <tr
                  v-for="( err, i ) in errorsArrays"
                  :key="i"
                >
                  <td
                    v-for="( errProp, j ) in err"
                    :key="i + '_' + j"
                  >{{ errProp }}</td>
                </tr>
              </table>
            </template>
          </template>
        </template>
        <div
          class="empty"
          v-else
        >
          {{ $t( "noErrorsFound" ) }}
        </div>
      </Loading>
    </Modal>
  </Loading>
</template>

<script>
import Loading from "@/components/Loading";
import Modal from "@/components/Modal";
import Icon from "@/components/Icon";

import dates from "@/dates"
import utils from "@/utils"
import login from "../pages/login";

export default {
	name: "Scheduler",

	components: {
		Modal,
    Loading,
    Icon
	},

  i18n: {
    messages: {
      ru: {
        Scheduler: "Планировщик задач",

        TaskType: "тип",
        TaskCreated: "создано",
        TaskStarted: "начало",
        TaskFinished: "окончание",
        TaskAutoremove: "автоудаление",
        TaskStatus: "статус",
        TaskErrorsCount: "ошибок",
        TaskAttachments: "файлы",

        statusReceived: "получено",
        statusPending: "ожидание",
        statusRunning: "выполнение",
        statusFinished: "завершено",
        statusStopped: "остановлено",
        statusFailed: "неуспешно",

        noTasksFound: "задачи отсутствуют",
        noErrorsFound: "ошибок не найдено",

        run: "запустить",
        stop: "остановить",
        remove: "удалить",

        days: "д.",
        hours:"ч.",
        mins: "м.",

        TaskErrors: "Ошибки задачи",
        errRowNumber: "строка №",
        errRowURI: "URI",
        errRowMsg: "сообщение",

        XLSimport: "импорт из Excel",
        XLSexport: "экспорт в Excel"
      },

      en: {
        Scheduler: "Task scheduler",

        TaskType: "type",
        TaskCreated: "created",
        TaskStarted: "started",
        TaskFinished: "finished",
        TaskAutoremove: "autoremove",
        TaskStatus: "status",
        TaskErrorsCount: "errors",
        TaskAttachments: "files",

        statusReceived: "received",
        statusPending: "pending",
        statusRunning: "running",
        statusFinished: "finished",
        statusStopped: "stopped",
        statusFailed: "failed",

        noTasksFound: "no tasks are found",
        noErrorsFound: "no errors are found",

        run: "run",
        stop: "stop",
        remove: "delete",

        days: "d.",
        hours:"h.",
        mins: "m.",

        TaskErrors: "Task errors",
        errRowNumber: "row №",
        errRowURI: "URI",
        errRowMsg: "message",

        XLSimport: "Excel import",
        XLSexport: "Excel export"
      },

      kz: {
        Scheduler: "Тапсырманы жоспарлаушы",

        TaskType: "түрі",
        TaskCreated: "құрылды",
        TaskStarted: "басталды",
        TaskFinished: "аяқталды",
        TaskAutoremove: "автоматтыжою",
        TaskStatus: "күй",
        TaskErrorsCount: "қателер",
        TaskAttachments: "файлдар",

        statusReceived: "алды",
        statusPending: "күтуде",
        statusRunning: "жүгіру",
        statusFinished: "аяқталды",
        statusStopped: "тоқтады",
        statusFailed: "сәтсізаяқталды",

        noTasksFound: "тапсырмалар табылмайды",
        noErrorsFound: "қателер табылмайды",

        run: "жүгіру",
        stop: "Тоқта",
        remove: "жою",

        days: "к.",
        hours:"с.",
        mins: "м.",

        TaskErrors: "Тапсырма қателері",
        errRowNumber: "жол №",
        errRowURI: "URI",
        errRowMsg: "хабар",

        XLSimport: "Excel импорты",
        XLSexport: "Excel экспорты"
      }
    }
  },

	props:      {
	  type: {
	    type: String,
      default: null
    },

    active: {
	    type: Boolean,
      default: true
    },

    refreshTime: {
	    type: Number,
      default: 5000
    },

    params: {
	    type: Object,
      default: () => ( {} )
    }
	},

  data() {
	  return {
      loading: true,
      hide: true,

      tasks:   null,

      errorsShow: false,
      errorsTaskId: null,
      errors: null
    };
  },

  taskStatuses: {
    received:   1,
    pending:    2,
    running:    3,
    finished:   4,
    stopped:    5,
    failed:     6
  },

  tid: null,

  mounted() {
    this.init( false );
  },
  beforeUnmount() {
    this.init( false );
  },

  methods:    {
	  download( task, aid, e ) {
	    if ( !this.$options.ifr ) {
        const ifr = document.createElement( "iframe" );
        ifr.style.position = "absolute";
        ifr.style.left = "-100000px";
        ifr.style.top = "-100000px";
        ifr.style.width = "1px";
        ifr.style.height = "1px";
        document.body.appendChild( ifr );
        this.$options.ifr = ifr;
      }

      this.$options.ifr.setAttribute( "src", this.$options.api.path2url( '/scheduler/' + task.id + '/attachment/' + aid ) )

	    if ( e ) e.preventDefault();

	    return false;
    },

	  date( d ) {
      return d ? dates.format( d, dates.types.UTS, dates.types.RUS, true, true, true ) : "";
    },

    taskIsStopped( task ) {
      return task.status == this.$options.taskStatuses.finished || task.status == this.$options.taskStatuses.failed || task.status == this.$options.taskStatuses.stopped;
    },

    timeToHTML( time ) {
	    if ( !time ) return "";

	    const d = Math.floor( time / 86400 );
	    time = time % 86400;
      const h = Math.floor( time / 3600);
      time = time % 3600;
      const m = Math.floor( time / 60 );

      let html = "";
      if ( d ) html += ( d ? " " : "" ) + d + ' <span>' + this.$t( "days" ) + '</span>';
      if ( h ) html += ( h ? " " : "" ) + h + ' <span>' + this.$t( "hours" ) + '</span>';
      if ( m ) html += ( m ? " " : "" ) + h + ' <span>' + this.$t( "mins" ) + '</span>';

      return html;
    },

    taskStatus( status ) {
	    for ( const id in this.$options.taskStatuses ) {
	      if ( this.$options.taskStatuses.hasOwnProperty( id ) && this.$options.taskStatuses[ id ] === status ) {
	        return "status" + id.charAt( 0 ).toUpperCase() + id.slice( 1 );
        }
      }

	    return "";
    },

    async init( state ) {
      this.tasks = null;
      this.hide = true;
      this.errorsShow = false;
      this.loading = true;

      if ( state ) await this.tasksRequest();
      await this.refresh( state );

      this.loading = false;
      this.hide = false;
    },

    async refresh( state ) {
      if ( this.$options.tid ) {
        clearTimeout( this.$options.tid );
        this.$options.tid = null;
      }

      if ( state && this.refreshTime ) {
        this.$options.tid = setTimeout(
          async () => {
            await this.tasksRequest();
            await this.refresh( this.active );
          },

          this.refreshTime
        );
      }
    },

    async tasksRequest() {
      try {
        const ans = await this.$options.api.post.json(
          "/scheduler/list",
          this.params,
          undefined,
          false
        );

        this.tasks = ans.tasks;
      }
      catch ( e ) {
        console.error( e );
      }
    },

    async errorsOpen( taskId ) {
      this.errors = null;
      this.errorsTaskId = taskId;
      this.errorsShow = true;

      try {
        const ans = await this.$options.api.post.json(
          "/scheduler/" + taskId,
          this.params,
          undefined,
          false
        );

        this.errors = ans.task.errors;
      }
      catch ( e ) {
        console.error( e );
        this.errorsShow = false;
        this.errorsTaskId = null;
        this.$root.$emit( "notify", { header: this.$t( "DataRequestError" ), message: e.message, type: "error" } );
      }
    },

    async taskCreate( typeOrFormData, parameters ) {
	    this.loading = true;

	    const options = {};

	    try {
  	    if ( typeOrFormData instanceof FormData ) {
  	      options.dataRaw = true;
  	      parameters = typeOrFormData;
  	      typeOrFormData = undefined;
        }
  	    else {
  	      if ( !typeOrFormData ) typeOrFormData = "SCHtest";
    	    if ( !parameters ) parameters = {};

          parameters = {
            ...this.params,
            ...parameters,
            type: "" + typeOrFormData
          };
        }

        const ans = await this.$options.api.put.json(
          "/scheduler",
          parameters,
          options,
          false
        );

        if ( ans && ans.task && ans.task.id ) {
          await this.tasksRequest();
          await this.refresh( true );
        }
      }
      catch ( e ) {
        console.error( e );
      }

	    this.loading = false;
	  },

    async taskCommand( task, command ) {
	    this.loading = true;

	    try {
        const ans = await this.$options.api.patch.json(
          "/scheduler/" + task.id + "/" + command,
            {
              ...this.params,
              type: "XLSimport"
            },
            undefined,
            false
        );

        if ( ans ) {
          await this.tasksRequest();
          await this.refresh( true );
        }
      }
      catch ( e ) {
        console.error( e );
      }

	    this.loading = false;
    }
	},

  computed: {
    errorsStrings() {
      const errors = []

      if ( this.errors ) {
        for ( const err of this.errors ) {
          if ( typeof( err ) === "string" ) errors.push( err );
          else if ( !Array.isArray( err ) ) errors.push( JSON.stringify( err, null, 2 ) ); //if other than array - convert to string
        }
      }

      return errors.length ? errors : null;
    },

    errorsArrays() {
      const errors = [];

      if ( this.errors ) {
        for ( const err of this.errors ) {
          if ( Array.isArray( err ) ) errors.push( err );
        }
      }

      return errors.length ? errors : null;
    }
  },

  watch: {
	  active: {
	    immediate: true,
      handler() {
	      this.init( this.active );
      }
    }
  }
};
</script>

<style scoped>
.items {
  width: 100%;
}
.items th {
  font-weight: bold;
  background-color: #40B8ED;
  color: #FFFFFF;
}
.items th,
.items td {
  padding: 0.2em 0.5em;
  vertical-align: top;
  text-align: left;
}
.items th:first-child,
.items td:first-child {
  border-top-left-radius: 0.2em;
  border-bottom-left-radius: 0.2em;
}
.items th:last-child,
.items td:last-child {
  border-top-right-radius: 0.2em;
  border-bottom-right-radius: 0.2em;
}
.items tr:last-child th,
.items tr:last-child td {
  padding-bottom: 0;
}
.items tr:nth-child( odd ) td {
 background-color: #F0F0F0;
}
.items tr:hover > td {
  background-color: #bcebff;
}

.tasks .progress > .bar {
  font-size: 0.7em;
  position: relative;
  min-width: 5em;
  width: 100%;
  display: inline-block;

  background-image:
    linear-gradient( 90deg, #000000 50%, transparent 50% ),
    linear-gradient( 90deg, #000000 50%, transparent 50% ),
    linear-gradient( 0deg,  #000000 50%, transparent 50% ),
    linear-gradient( 0deg,  #000000 50%, transparent 50% );
  background-repeat: repeat-x, repeat-x, repeat-y, repeat-y;
  background-size: 5px 1px, 5px 1px, 1px 5px, 1px 5px;
  background-position: left top, right bottom, left bottom, right   top;
  animation: borderMove .5s infinite linear;

  border-radius: 0.2em;
  text-align: center;

  padding: 0.12em 0;

  --amount: 0;
}
@keyframes borderMove {
  0% {
    background-position: left top, right bottom, left bottom, right   top;
  }
  100% {
    background-position: left 5px top, right 5px bottom, left bottom 5px, right top 5px;
  }
}

.tasks .progress > .bar:before {
  content: "";
  position: absolute;
  top: 2px;
  left: 2px;
  bottom: 2px;
  width: calc( var( --amount ) * 1% - 4px );
  background-color: #000000;
  border-radius: 0.2em;
  z-index: 1;
  transition: all .2s linear;
}
.tasks .progress > .bar:after {
  counter-reset: amount var( --amount );
  content: counter( amount ) "%";
  position: relative;
  z-index: 3;
  color: #000000;
  vertical-align: -0.12em;
  text-shadow:
		-0   -1px 0   #FFFFFF,
		 0   -1px 0   #FFFFFF,
		-0    1px 0   #FFFFFF,
		 0    1px 0   #FFFFFF,
		-1px -0   0   #FFFFFF,
		 1px -0   0   #FFFFFF,
		-1px  0   0   #FFFFFF,
		 1px  0   0   #FFFFFF,
		-1px -1px 0   #FFFFFF,
		 1px -1px 0   #FFFFFF,
		-1px  1px 0   #FFFFFF,
		 1px  1px 0   #FFFFFF,
		-1px -1px 0   #FFFFFF,
		 1px -1px 0   #FFFFFF,
		-1px  1px 0   #FFFFFF,
		 1px  1px 0   #FFFFFF;
}
.tasks .datetime {
  font-size: 0.8em;
  text-align: center;
}
.tasks .datetime > span {
  display: inline-block;
  width: 4em;
}

.tasks .errorsCount {
  text-align: center;
}
.tasks .errorsCount > span {
  color: #FF0000;
  cursor: pointer;
  text-decoration: underline;
}
.tasks .errorsCount > span:hover {
  text-decoration: none;
}

.tasks .attachments a {
  display: block;
}
.statusPending {
  color: #A0A000;
}
.statusFinished {
  color: #00A000;
}
.statusFailed {
  color: #A00000;
}

.tasks .autoremove {
  text-align: center;
  font-size: 0.8em;
}
.tasks .autoremove > span {
  font-size: 0.7em;
}

.tasks .controls {
  text-align: center;
  vertical-align: top;
  white-space: nowrap;
}

button {
  display: inline-block;
  border: none;
  padding: 0;
  background: none;
  cursor: pointer;
  margin: 0 0.5em;
  transition: all .2s linear;
  color: #000000;
}

button:hover,
button:hover * {
  color: #F00000;
}

button.disabled {
  pointer-events: none;
  opacity: 0.3;
  cursor: default;
}
</style>
